import { Place } from 'features/places/places.types';

type GetMapPinHeaderTitleArgs = {
  pinImprovements: boolean;
  place?: Place;
  address?: string | null;
  addressLabel: string;
  countyName: string;
};

export const getMapPinHeaderTitle = ({
  pinImprovements,
  place,
  address,
  addressLabel,
  countyName,
}: GetMapPinHeaderTitleArgs): string => {
  if (!pinImprovements) {
    return countyName;
  }

  if (place) {
    return place.name;
  }

  if (address) {
    return addressLabel;
  }

  return countyName;
};

export const formatAddressMultiline = (address: string): string[] => {
  const parts = address
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);

  // If only 1 comma, we just  have  <City>, <State>
  if (parts.length <= 2) {
    return [address.trim()];
  }

  const [street, ...rest] = parts;
  return [street, rest.join(', ')];
};
